import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FuseCardComponent } from '@fuse/components/card';
import { GoogleMapsModule } from '@angular/google-maps';
import { ILead } from 'app/core/shared-services/shared-interface.types';
import { IPackages } from 'app/core/shared-services/interfaces.types';
import { environment } from 'environments/environment';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { MatIconModule } from '@angular/material/icon';
import { TermsComponent } from '../terms/terms.component';

@Component({
  selector: 'app-summary',
  standalone: true,
  imports: [CommonModule, FuseCardComponent, MatIconModule, GoogleMapsModule, CurrencyPipe, TermsComponent],
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent {

  @Input() lead: ILead;
  @Input() center: any;
  @Input() order: IPackages;
  @Input() addOns: IPackages;
  @Input() upFrontAmount: number;
  @Input() monthlyAmount: number;
  @Input() VAT: number;

  @Output() acceptedTerms = new EventEmitter();

  public zoom: number = 16;
  public mapOptions: any;
  public logo: string;
  public allTermsAccepted: any;
  private integrationUrl = environment.integrationUrl;
 
  constructor(
    private _sharedMethods: SharedMethodsModule,
  ) {
    
  }

  ngOnChanges() {
    this.mapOptions = {
      zoom: 16,
      center: new google.maps.LatLng(this.center?.lat, this.center?.lng),
      styles: [{
        stylers: [{
          saturation: -100
        }]
      }]
    };
  }

  public getProviderLogo(PackageSupplierOrganisationEntityID: number) {
    return this.integrationUrl + '/organisations/' + PackageSupplierOrganisationEntityID + '/logo';
  }

  public getThumbnail(OfferableEntityID: number) {
    return this.integrationUrl + '/offerables/items/' + OfferableEntityID + '/thumbnail';
  }

  public termsCheck(value: any) {
    const acceptedTerms = value;
    this.allTermsAccepted = acceptedTerms.every(element => element.isAccepted);
    this.acceptedTerms.emit(value);
  }
  
}
